import React, { useEffect, useState } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import {
  LayoutDashboard, Sparkles, Library, Mic2, CalendarRange,
  BarChart3, Users, Radio, CreditCard, LogOut, ChevronLeft, ChevronDown,
  Mic, Plug, Volume2, Rss, Headphones, Megaphone, Newspaper, FileEdit, Palette, Zap, Share2, Crown, Video, Cpu, GraduationCap, Music, CalendarClock, SlidersHorizontal, Layers3, Mic as MicIcon2, Radio as RadioIcon, MicVocal as KaraokeMic, Activity, Podcast, Inbox, TrendingUp, Mail, ListChecks, LifeBuoy, Headset, BookOpen, Clapperboard, ScrollText, Lock, Disc3, Star, Languages, TicketPercent, Bot, Server as Server2, RadioTower, Scissors, ListMusic, X,
} from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";
import { api } from "@/lib/api";
import { useT } from "@/lib/i18n";
import WorkspaceCard from "@/components/WorkspaceCard";

/**
 * NAV — 7 functional groups (2026 nav reorganization).
 * Groups with a `to` open their hub page; the chevron toggles the list.
 * Groups without a `to` toggle on click. Nested children (Podcast Studio)
 * render one extra level deep.
 */
export const NAV = [
  { to: "/dashboard", label: "Control Room", icon: LayoutDashboard, testid: "nav-dashboard" },
  {
    to: "/dashboard/news-center",
    label: "Content Creation",
    icon: Newspaper,
    testid: "nav-content-creation",
    children: [
      { to: "/dashboard/news-ingestion", label: "News Ingestion", icon: Rss,        testid: "nav-news-ingestion" },
      { to: "/dashboard/news-studio",    label: "News Studio",    icon: Mic,        testid: "nav-news-studio" },
      { to: "/dashboard/news",           label: "AI Music News",  icon: Newspaper,  testid: "nav-news-hub" },
      { to: "/dashboard/rss-feeds",      label: "RSS Feeds",      icon: Rss,        testid: "nav-rss-feeds" },
      { to: "/dashboard/blog-connector", label: "Blog Connector", icon: FileEdit,   testid: "nav-blog-connector" },
      { to: "/dashboard/writers-desk",   label: "Editorial Desk", icon: BookOpen,   testid: "nav-writers-desk" },
      { to: "/dashboard/marketing-kit",  label: "Marketing Kit",  icon: Palette,    testid: "nav-marketing-kit" },
      { to: "/dashboard/newsletter",     label: "Newsletter",     icon: Mail,       testid: "nav-newsletter" },
      { to: "/dashboard/top-charts",     label: "Top Charts",     icon: TrendingUp, testid: "nav-top-charts" },
    ],
  },
  { to: "/dashboard/language-center", label: "Language Center", icon: Languages, testid: "nav-language-center" },
  {
    to: "/dashboard/magazine",
    label: "Digital Magazine",
    icon: BookOpen,
    testid: "nav-magazine",
    featureKey: "magazine",
    children: [
      { to: "/dashboard/magazine",            label: "Overview",         icon: TrendingUp,    testid: "nav-mag-overview" },
      { to: "/dashboard/magazine/articles",   label: "Articles",         icon: Newspaper,     testid: "nav-mag-articles" },
      { to: "/dashboard/magazine/ai-writer",  label: "AI Writer",        icon: Sparkles,      testid: "nav-mag-ai-writer" },
      { to: "/dashboard/magazine/categories", label: "Categories",       icon: ListChecks,    testid: "nav-mag-categories" },
      { to: "/dashboard/magazine/authors",    label: "Authors",          icon: Mic,           testid: "nav-mag-authors" },
      { to: "/dashboard/magazine/media",      label: "Media Library",    icon: Palette,       testid: "nav-mag-media" },
      { to: "/dashboard/magazine/analytics",  label: "Analytics",        icon: Activity,      testid: "nav-mag-analytics" },
      { to: "/dashboard/magazine/newsletter", label: "Newsletter",       icon: Mail,          testid: "nav-mag-newsletter" },
      { to: "/dashboard/magazine/settings",   label: "Magazine Settings", icon: SlidersHorizontal, testid: "nav-mag-settings" },
    ],
  },
  {
    to: "/dashboard/engagement",
    label: "Engagement",
    icon: Headset,
    testid: "nav-engagement",
    children: [
      { to: "/dashboard/engagement",             label: "Overview",      icon: TrendingUp, testid: "nav-eng-overview" },
      { to: "/dashboard/engagement/inbox",       label: "Inbox",         icon: Inbox,      testid: "nav-eng-inbox" },
      { to: "/dashboard/engagement/requests",    label: "Song Requests", icon: Music,      testid: "nav-eng-requests" },
      { to: "/dashboard/engagement/dedications", label: "Dedications",   icon: Mail,       testid: "nav-eng-dedications" },
      { to: "/dashboard/engagement/polls",       label: "Polls",         icon: Activity,   testid: "nav-eng-polls" },
      { to: "/dashboard/engagement/contests",    label: "Contests",      icon: Star,       testid: "nav-eng-contests" },
      { to: "/dashboard/engagement/listeners",   label: "Listeners",     icon: Users,      testid: "nav-eng-listeners" },
      { to: "/dashboard/engagement/analytics",   label: "Analytics",     icon: TrendingUp, testid: "nav-eng-analytics" },
      { to: "/dashboard/engagement/rewards",     label: "Rewards",       icon: Crown,      testid: "nav-eng-rewards" },
      { to: "/dashboard/engagement/voice",       label: "Voice Inbox",   icon: Mic,        testid: "nav-eng-voice" },
      { to: "/dashboard/engagement/settings",    label: "Settings",      icon: SlidersHorizontal, testid: "nav-eng-settings" },
    ],
  },
  {
    to: "/dashboard/studio-city",
    label: "Studio City",
    icon: Clapperboard,
    testid: "nav-studio-city",
    children: [
      { to: "/dashboard/generate",            label: "AI Studio",           icon: Sparkles,          testid: "nav-generate" },
      { to: "/dashboard/music-studio",        label: "AI Music Studio",     icon: Music,             testid: "nav-music-studio-top" },
      { to: "/dashboard/vision-studio",       label: "Vision Studio",       icon: Video,             testid: "nav-vision-studio-main", badge: "PRO", featureKey: "vision_studio" },
      { to: "/dashboard/audio-studio",        label: "Audio Studio",        icon: Volume2,           testid: "nav-audio-studio" },
      { to: "/dashboard/avatar-studio",       label: "AI Avatar Studio",    icon: Mic2,              testid: "nav-avatar-studio" },
      { to: "/dashboard/imaging",             label: "Imaging Studio",      icon: Volume2,           testid: "nav-imaging" },
      { to: "/dashboard/stem-studio",         label: "Stem Studio",         icon: Layers3,           testid: "nav-stem-studio", featureKey: "stem_studio" },
      { to: "/dashboard/rip-tag-studio",      label: "Rip & Tag Studio",    icon: Disc3,             testid: "nav-rip-tag-studio" },
      { to: "/dashboard/music-library",       label: "AI Music Library",    icon: ListMusic,         testid: "nav-music-library", badge: "NEW" },
      { to: "/dashboard/snippet-studio",      label: "Snippet Studio",      icon: Scissors,          testid: "nav-snippet-studio", badge: "NEW" },
      { to: "/dashboard/vocalist-studio",     label: "AI Vocalist Studio",  icon: MicIcon2,          testid: "nav-vocalist-studio", featureKey: "vocalist_studio" },
      { to: "/dashboard/karaoke-studio",      label: "Karaoke Studio",      icon: KaraokeMic,        testid: "nav-karaoke-studio" },
      { to: "/dashboard/karaoke-prompter",    label: "Karaoke Prompter",    icon: KaraokeMic,        testid: "nav-karaoke-prompter" },
      { to: "/dashboard/artist-drops",        label: "Voice Drops",         icon: MicIcon2,          testid: "nav-artist-drops" },
      { to: "/dashboard/quick-promo-creator", label: "Quick Promo Creator", icon: Zap,               testid: "nav-quick-promo-creator" },
      { to: "/dashboard/commercials",         label: "Commercials",         icon: Megaphone,         testid: "nav-commercials" },
      { to: "/dashboard/production-suite",    label: "Production Suite",    icon: SlidersHorizontal, testid: "nav-production-suite" },
      { to: "/dashboard/production",          label: "Production Hub",      icon: Layers3,           testid: "nav-production-hub" },
      {
        to: "/dashboard/podcasts",
        label: "Podcast Studio",
        icon: Podcast,
        testid: "nav-podcast-studio",
        children: [
          { to: "/dashboard/podcasts",        label: "Podcast Vault",   icon: Mic2,    testid: "nav-podcasts" },
          { to: "/dashboard/podcast-creator", label: "Podcast Creator", icon: Podcast, testid: "nav-podcast-creator" },
        ],
      },
    ],
  },
  {
    to: "/dashboard/live-on-air",
    label: "Live & On-Air",
    icon: RadioIcon,
    testid: "nav-live-onair",
    children: [
      { to: "/dashboard/ai-dj",        label: "AI DJ Assistant", icon: Headphones,    testid: "nav-ai-dj" },
      { to: "/dashboard/prompter",     label: "The Prompter",    icon: ScrollText,    testid: "nav-prompter" },
      { to: "/dashboard/automation",   label: "Push to Air",     icon: RadioIcon,     testid: "nav-automation" },
      { to: "/guide",                  label: "Program Guide",   icon: CalendarClock, testid: "nav-program-guide" },
      { to: "/dashboard/request-line", label: "Request Line",    icon: Inbox,         testid: "nav-request-line" },
      { to: "/dashboard/nowplaying",   label: "Now Playing",     icon: Rss,           testid: "nav-nowplaying" },
      { to: "/dashboard/sam-broadcaster", label: "SAM Broadcaster", icon: Server2, testid: "nav-sam-broadcaster" },
      { to: "/dashboard/broadcast-hub", label: "Broadcast Hub", icon: RadioTower, testid: "nav-broadcast-hub" },
    ],
  },
  {
    to: "/dashboard/distribution",
    label: "Distribution",
    icon: Share2,
    testid: "nav-distribution",
    children: [
      { to: "/dashboard/social-connections", label: "Social Connections", icon: Share2,        testid: "nav-social-connections" },
      { to: "/dashboard/integrations",       label: "Integrations",       icon: Plug,          testid: "nav-integrations" },
      { to: "/dashboard/calendar",           label: "Schedule",           icon: CalendarRange, testid: "nav-calendar" },
    ],
  },
  {
    to: "/dashboard/station-ops",
    label: "Station Operations",
    icon: Radio,
    testid: "nav-station-ops",
    children: [
      { to: "/dashboard/team",       label: "Team",            icon: Users,         testid: "nav-team" },
      { to: "/dashboard/station",    label: "Station",         icon: Radio,         testid: "nav-station" },
      { to: "/dashboard/providers",  label: "AI Providers",    icon: Cpu,           testid: "nav-ai-providers" },
      { to: "/dashboard/library",    label: "Content Library", icon: Library,       testid: "nav-library" },
      { to: "/dashboard/transcribe", label: "Transcribe",      icon: Mic,           testid: "nav-transcribe" },
      { to: "/dashboard/analytics",  label: "Analytics",       icon: BarChart3,     testid: "nav-analytics" },
      { to: "/dashboard/academy",    label: "Academy",         icon: GraduationCap, testid: "nav-academy", badge: "PRO", featureKey: "academy" },
    ],
  },
  {
    to: "/dashboard/account",
    label: "Account",
    icon: CreditCard,
    testid: "nav-account",
    children: [
      { to: "/dashboard/billing", label: "Billing",        icon: CreditCard, testid: "nav-billing" },
      { to: "/dashboard/assistant", label: "Flow Assistant", icon: Bot, testid: "nav-flow-assistant" },
      { to: "/dashboard/help",    label: "Help & Support", icon: LifeBuoy,   testid: "nav-help-support" },
    ],
  },
];

const keyOf = (n) => n.to || n.label;

const ADMIN_NAV_ITEM = {
  to: "/dashboard/admin/credits",
  label: "Admin · Credits",
  icon: Crown,
  testid: "nav-admin-credits",
};

const ADMIN_RELIABILITY_ITEM = {
  to: "/dashboard/admin/reliability",
  label: "Admin · Reliability",
  icon: Activity,
  testid: "nav-admin-reliability",
};

const ADMIN_TICKETS_ITEM = {
  to: "/dashboard/admin/tickets",
  label: "Admin · Tickets",
  icon: Inbox,
  testid: "nav-admin-tickets",
};

const ADMIN_ONBOARDING_ITEM = {
  to: "/dashboard/admin/onboarding",
  label: "Admin · Onboarding",
  icon: ListChecks,
  testid: "nav-admin-onboarding",
};

const ADMIN_SUPPORT_ITEM = {
  to: "/dashboard/admin/support",
  label: "Admin · Support",
  icon: Headset,
  testid: "nav-admin-support",
};

const ADMIN_HELP_CONTENT_ITEM = {
  to: "/dashboard/admin/help-content",
  label: "Admin · Help Content",
  icon: BookOpen,
  testid: "nav-admin-help-content",
};

const ADMIN_PROMOS_ITEM = {
  to: "/dashboard/admin/promo-codes",
  label: "Admin · Promo Codes",
  icon: TicketPercent,
  testid: "nav-admin-promo-codes",
};

const ADMIN_REVENUE_ITEM = {
  to: "/dashboard/admin/revenue",
  label: "Admin · Revenue",
  icon: TrendingUp,
  testid: "nav-admin-revenue",
};

const ADMIN_ASSISTANT_ITEM = {
  to: "/dashboard/admin/assistant",
  label: "Admin · Assistant",
  icon: Bot,
  testid: "nav-admin-assistant",
};

export default function Sidebar({ collapsed: collapsedProp, onToggle, mobileOpen = false, onMobileClose }) {
  const { user, logout } = useAuth();
  // The mobile drawer always shows full labels regardless of the desktop collapse state
  const collapsed = mobileOpen ? false : collapsedProp;
  const navigate = useNavigate();
  const location = useLocation();
  const t = useT();

  const [featureAccess, setFeatureAccess] = useState(null);
  useEffect(() => {
    api.get("/feature-access").then((r) => setFeatureAccess(r.data)).catch(() => {});
  }, []);

  const badgeFor = (item) => {
    if (item.featureKey && featureAccess) {
      if (featureAccess[item.featureKey] === false) return "__LOCK__";
      return item.badge && item.badge !== "PRO" ? item.badge : null;
    }
    return item.badge || null;
  };

  const logLockedClick = (item, source) => {
    if (badgeFor(item) === "__LOCK__") {
      api.post("/upgrade-interest", { feature: item.featureKey, source }).catch(() => {});
    }
  };

  const renderBadge = (item) => {
    const b = badgeFor(item);
    if (!b) return null;
    if (b === "__LOCK__") {
      return (
        <span data-testid={`${item.testid}-pro-lock`}
          className="ml-auto inline-flex items-center gap-0.5 text-[8px] font-mono uppercase tracking-wider px-1.5 py-0.5 rounded bg-brand-amber/15 text-brand-amber">
          <Lock className="h-2.5 w-2.5" /> PRO
        </span>
      );
    }
    return (
      <span className="ml-auto text-[8px] font-mono uppercase tracking-wider px-1.5 py-0.5 rounded bg-brand-amber/15 text-brand-amber">
        {b}
      </span>
    );
  };

  // Active when the group's own hub route or any (nested) child route matches.
  const groupIsActive = (group) =>
    (group.to && location.pathname === group.to) ||
    (group.children || []).some(
      (c) =>
        (c.to && location.pathname.startsWith(c.to)) ||
        (c.children || []).some((g) => location.pathname.startsWith(g.to))
    );

  // All groups (and sub-groups) start expanded — mirrors the reorg mockup.
  const [openGroups, setOpenGroups] = useState(() => {
    const init = {};
    const seed = (items) => items.forEach((n) => {
      if (n.children) { init[keyOf(n)] = true; seed(n.children); }
    });
    seed(NAV);
    return init;
  });

  // Re-expand the active group when route changes (keeps user's manual toggles otherwise)
  useEffect(() => {
    setOpenGroups((prev) => {
      const next = { ...prev };
      const visit = (items) => items.forEach((n) => {
        if (n.children) {
          if (groupIsActive(n)) next[keyOf(n)] = true;
          visit(n.children);
        }
      });
      visit(NAV);
      return next;
    });
  }, [location.pathname]);

  const toggleGroup = (key) => setOpenGroups((g) => ({ ...g, [key]: !g[key] }));

  const renderLeaf = (item, depth = 0) => (
    <NavLink
      key={item.to}
      to={item.to}
      end={item.to === "/dashboard"}
      data-testid={item.testid}
      onClick={() => logLockedClick(item, "sidebar")}
      className={({ isActive }) =>
        `flex items-center ${depth ? "gap-2.5 px-3 py-2" : "gap-3 px-3 py-2.5"} rounded-md type-sidebar-nav transition ${
          isActive
            ? "bg-bg-elevated text-brand-amber border border-line"
            : "text-ink-secondary hover:text-ink-primary hover:bg-bg-elevated/60"
        }`
      }
    >
      <item.icon className={depth ? "h-3.5 w-3.5 shrink-0" : "h-4 w-4 shrink-0"} />
      {!collapsed && <span className="flex-1">{t(item.label)}</span>}
      {!collapsed && renderBadge(item)}
    </NavLink>
  );

  // One level of nesting inside a group (Podcast Studio → Vault / Creator)
  const renderSubGroup = (c) => {
    const subKey = keyOf(c);
    const subOpen = !!openGroups[subKey];
    const subActive = groupIsActive(c);
    return (
      <div key={`grp-${subKey}`} data-testid={`nav-group-${c.testid}`}>
        <div className="flex items-stretch">
          <NavLink
            to={c.to}
            end
            data-testid={c.testid}
            className={({ isActive }) =>
              `flex flex-1 items-center gap-2.5 rounded-l-md px-3 py-2 type-sidebar-nav transition ${
                isActive || subActive
                  ? "bg-bg-elevated text-brand-amber border-y border-l border-line"
                  : "text-ink-secondary hover:text-ink-primary hover:bg-bg-elevated/60"
              }`
            }
          >
            <c.icon className="h-3.5 w-3.5 shrink-0" />
            {!collapsed && <span className="flex-1">{t(c.label)}</span>}
            {!collapsed && renderBadge(c)}
          </NavLink>
          {!collapsed && (
            <button
              onClick={(e) => { e.preventDefault(); toggleGroup(subKey); }}
              className={`rounded-r-md px-2 transition ${
                subActive ? "bg-bg-elevated text-brand-amber border-y border-r border-line"
                          : "text-ink-muted hover:text-ink-primary hover:bg-bg-elevated/60"
              }`}
              data-testid={`${c.testid}-toggle`}
              aria-label={`Toggle ${c.label} group`}
            >
              <ChevronDown className={`h-3.5 w-3.5 transition-transform ${subOpen ? "" : "-rotate-90"}`} />
            </button>
          )}
        </div>
        {(collapsed || subOpen) && (
          <div
            className={collapsed ? "mt-0.5 mb-1 flex flex-col gap-0.5" : "ml-3 mt-0.5 mb-1 border-l border-line pl-2 flex flex-col gap-0.5"}
            data-testid={`${c.testid}-children`}
          >
            {c.children.map((g) => renderLeaf(g, 2))}
          </div>
        )}
      </div>
    );
  };

  return (
    <aside
      className={`fixed left-0 top-0 z-40 flex h-screen flex-col border-r border-line bg-bg-surface transition-all duration-300 w-[280px] max-w-[85vw] ${
        mobileOpen ? "translate-x-0" : "-translate-x-full"
      } md:translate-x-0 ${collapsed ? "md:w-[72px]" : "md:w-[248px]"}`}
      data-testid="sidebar"
    >
      {/* Header — logo + collapse */}
      <div className="flex h-16 shrink-0 items-center justify-between px-4 border-b border-line">
        <button
          onClick={() => navigate("/dashboard")}
          className="flex items-center group"
          data-testid="sidebar-logo"
        >
          <div className="relative">
            <img
              src="/brand/broadcastflowai-hero.png"
              alt="BroadcastFlow AI"
              className={`object-contain ${collapsed ? "h-12 w-12" : "h-16 w-auto max-w-[180px]"}`}
            />
            <span className="absolute right-0 top-0 h-2 w-2 rounded-full bg-brand-onair onair-dot" />
          </div>
        </button>
        <button
          onClick={onToggle}
          className="hidden md:block text-ink-muted hover:text-ink-primary transition"
          data-testid="sidebar-toggle"
        >
          <ChevronLeft className={`h-4 w-4 transition-transform ${collapsed ? "rotate-180" : ""}`} />
        </button>
        <button
          onClick={onMobileClose}
          className="md:hidden rounded-md p-1.5 text-ink-muted hover:text-ink-primary hover:bg-bg-elevated transition"
          data-testid="sidebar-mobile-close"
          aria-label="Close menu"
        >
          <X className="h-5 w-5" />
        </button>
      </div>

      {/* Workspace identity — shows which station the user is producing for */}
      <WorkspaceCard collapsed={collapsed} />

      {/* Scrollable nav — flex-1 so it shrinks before colliding with the footer */}
      <nav className="flex-1 min-h-0 overflow-y-auto sidebar-scroll px-2 py-3">
        <div className="flex flex-col gap-0.5">
          {[...NAV, ...(["super_admin", "sysadmin", "owner"].includes(user?.role) ? [ADMIN_NAV_ITEM, ADMIN_RELIABILITY_ITEM, ADMIN_TICKETS_ITEM, ADMIN_ONBOARDING_ITEM, ADMIN_SUPPORT_ITEM, ADMIN_HELP_CONTENT_ITEM, ADMIN_PROMOS_ITEM, ADMIN_REVENUE_ITEM, ADMIN_ASSISTANT_ITEM] : [])].map((n) => {
            if (n.children) {
              const gKey = keyOf(n);
              const open = !!openGroups[gKey];
              const parentActive = groupIsActive(n);
              const headClass = (isActive) =>
                `flex flex-1 items-center gap-3 rounded-l-md px-3 py-2.5 type-sidebar-nav transition ${
                  isActive || parentActive
                    ? "bg-bg-elevated text-brand-amber border-y border-l border-line"
                    : "text-ink-secondary hover:text-ink-primary hover:bg-bg-elevated/60"
                }`;
              return (
                <div key={gKey} data-testid={`nav-group-${n.testid}`}>
                  <div className="my-1.5 h-px bg-line/70" />
                  <div className="flex items-stretch">
                    {n.to ? (
                      <NavLink to={n.to} end data-testid={n.testid} className={({ isActive }) => headClass(isActive)} onClick={() => logLockedClick(n, "sidebar")}>
                        <n.icon className="h-4 w-4 shrink-0" />
                        {!collapsed && <span className="flex-1">{t(n.label)}</span>}
                        {!collapsed && renderBadge(n)}
                      </NavLink>
                    ) : (
                      <button
                        onClick={() => toggleGroup(gKey)}
                        data-testid={n.testid}
                        className={`${headClass(false)} rounded-l-md text-left`}
                      >
                        <n.icon className="h-4 w-4 shrink-0" />
                        {!collapsed && <span className="flex-1">{t(n.label)}</span>}
                      </button>
                    )}
                    {!collapsed && (
                      <button
                        onClick={(e) => { e.preventDefault(); toggleGroup(gKey); }}
                        className={`rounded-r-md px-2 transition ${
                          parentActive ? "bg-bg-elevated text-brand-amber border-y border-r border-line"
                                       : "text-ink-muted hover:text-ink-primary hover:bg-bg-elevated/60"
                        }`}
                        data-testid={`${n.testid}-toggle`}
                        aria-label={`Toggle ${n.label} group`}
                      >
                        <ChevronDown className={`h-3.5 w-3.5 transition-transform ${open ? "" : "-rotate-90"}`} />
                      </button>
                    )}
                  </div>
                  {(collapsed || open) && (
                    <div
                      className={collapsed ? "mt-0.5 mb-1 flex flex-col gap-0.5" : "ml-3 mt-0.5 mb-1 border-l border-line pl-2 flex flex-col gap-0.5"}
                      data-testid={`${n.testid}-children`}
                    >
                      {n.children.map((c) => (c.children ? renderSubGroup(c) : renderLeaf(c, 1)))}
                    </div>
                  )}
                </div>
              );
            }
            // Plain leaf nav item
            return renderLeaf(n, 0);
          })}
        </div>
      </nav>

      {/* Footer — usage meter + user card + sign out. Fixed in the flex column so it never overlaps nav. */}
      <div className="shrink-0 border-t border-line p-3">
        {!collapsed && <UsageMeter />}
        {!collapsed && user && (
          <div className="mb-2 rounded-lg bg-bg-elevated p-2.5 border border-line">
            <div className="flex items-center gap-2">
              {user.picture ? (
                <img src={user.picture} alt="" className="h-7 w-7 rounded-full" />
              ) : (
                <div className="h-7 w-7 rounded-full bg-brand-amber/20 text-brand-amber font-display text-xs flex items-center justify-center">
                  {user.name?.[0]?.toUpperCase()}
                </div>
              )}
              <div className="min-w-0">
                <div className="type-list-title text-ink-primary truncate">{user.name}</div>
                <div className="type-timestamp font-mono uppercase text-brand-amber tracking-wider truncate">
                  {user.role?.replace("_", " ")}
                </div>
                {user.founding_tester && (
                  <div className="mt-0.5 inline-flex items-center gap-1 rounded bg-amber-500/15 px-1.5 py-0.5 text-[8px] font-mono uppercase tracking-wider text-amber-300"
                       data-testid="founding-tester-badge">
                    ★ Founding #{user.founding_cohort_number}
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
        <button
          onClick={logout}
          className="flex w-full items-center gap-3 rounded-md px-3 py-2 type-sidebar-nav text-ink-secondary hover:bg-bg-elevated hover:text-brand-onair transition"
          data-testid="logout-btn"
        >
          <LogOut className="h-4 w-4 shrink-0" />
          {!collapsed && <span>{t("Sign out")}</span>}
        </button>
      </div>
    </aside>
  );
}

// ──────────────────────────────────────────────────────────────
// UsageMeter — tiny live "AI generations used this month" widget.
// Soft upsell: shows progress bar that turns amber→rose as user
// approaches their plan cap, with an "Upgrade" link on Free/Starter.
// ──────────────────────────────────────────────────────────────
function UsageMeter() {
  const [u, setU] = useState(null);
  useEffect(() => {
    let mounted = true;
    const load = async () => {
      try {
        const { data } = await api.get("/usage/current");
        if (mounted) setU(data);
      } catch { /* silent */ }
    };
    load();
    const id = setInterval(load, 60_000); // refresh every minute
    return () => { mounted = false; clearInterval(id); };
  }, []);

  if (!u) return null;
  const pct = u.unlimited ? 0 : Math.min(100, u.percent || 0);
  const isLow = !u.unlimited && pct >= 80;
  const isCritical = !u.unlimited && pct >= 95;
  const barClass = isCritical
    ? "bg-rose-400"
    : isLow
    ? "bg-amber-400"
    : "bg-brand-amber";
  const showUpgrade = ["free", "starter"].includes(u.plan);

  return (
    <div className="mb-2 rounded-lg border border-line bg-bg-elevated p-2.5" data-testid="sidebar-usage-meter">
      <div className="flex items-center justify-between mb-1.5">
        <div className="flex items-center gap-1.5">
          <Zap className="h-3 w-3 text-brand-amber" />
          <span className="text-[10px] font-mono uppercase tracking-[0.15em] text-ink-muted">
            AI usage
          </span>
        </div>
        <span className="text-[10px] font-mono uppercase tracking-wider text-brand-amber" data-testid="usage-plan-label">
          {u.plan}
        </span>
      </div>

      {u.unlimited ? (
        <div className="text-[11px] text-ink-primary font-mono" data-testid="usage-unlimited">
          <span className="text-emerald-400">∞</span> Unlimited
          <div className="text-[9px] text-ink-muted mt-0.5">{u.used} used this month</div>
        </div>
      ) : (
        <>
          <div className="flex items-baseline gap-1">
            <span className="text-sm font-bold text-ink-primary" data-testid="usage-used">{u.used}</span>
            <span className="text-[10px] text-ink-muted">/ {u.cap} gen</span>
          </div>
          <div className="mt-1.5 h-1.5 w-full rounded-full bg-bg-surface overflow-hidden">
            <div
              className={`h-full rounded-full transition-all ${barClass}`}
              style={{ width: `${pct}%` }}
              data-testid="usage-bar"
            />
          </div>
          {showUpgrade && (
            <NavLink
              to="/dashboard/billing?tab=plan"
              data-testid="usage-upgrade-link"
              className={`mt-1.5 block text-center text-[10px] font-mono uppercase tracking-wider rounded px-1.5 py-1 transition ${
                isCritical
                  ? "bg-rose-500/20 text-rose-300 hover:bg-rose-500/30"
                  : isLow
                  ? "bg-amber-500/20 text-amber-300 hover:bg-amber-500/30"
                  : "text-cyan-300 hover:text-cyan-200 hover:bg-cyan-500/10"
              }`}
            >
              {isCritical ? "Cap reached — upgrade" : isLow ? "Almost full — upgrade" : "Upgrade plan →"}
            </NavLink>
          )}
        </>
      )}
    </div>
  );
}
